import { useParams, useHistory } from 'react-router-dom';
import { useCallback, useEffect } from 'react';
import useOrder from 'data/hooks/useOrder';
import useOrderActions from 'data/hooks/useOrderActions';
import { markOrderAsSeen } from 'data/cacheHelpers/order';

const useConnect = () => {
  const { orderId } = useParams<{ orderId: string }>();
  const { location, push } = useHistory<{ prevPathname: string }>();
  const { order, isLoading } = useOrder(orderId);
  const {
    markReady,
    markComplete,
    printOrder,
    isLoading: isChangeStatusLoading,
  } = useOrderActions();

  useEffect(() => markOrderAsSeen(orderId), [orderId]);

  const handleClose = useCallback(() => {
    const prevLocation =
      (location.state && location.state.prevPathname) || '/orders/active';

    push(prevLocation);
  }, [location, push]);

  const handleMarkReady = useCallback(
    () => markReady({ orderId }),
    [markReady, orderId],
  );

  const handleMarkComplete = useCallback(
    () => markComplete({ orderId }),
    [markComplete, orderId],
  );

  const handlePrintOrder = useCallback(
    () => printOrder({ orderId }),
    [printOrder, orderId],
  );

  return {
    orderId,
    handleClose,
    order,
    isLoading,
    isChangeStatusLoading,
    handleMarkReady,
    handleMarkComplete,
    handlePrintOrder,
  };
};

export default useConnect;
